module.exports = __webpack_public_path__ + "img/2023-3.21686e66.jpg";